

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { colors, fonts } from '../shared/tokens';
import { Logo } from '../auth/authShared';

const LINKS = [
  { label: 'Solutions', href: '#solutions' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

const Nav = () => {
  const navigate = useNavigate();
  return (
    <Bar>
      <Inner>
        <Logo />
        <Links>
          {LINKS.map((l) => (
            <a key={l.label} href={l.href}>
              {l.label}
            </a>
          ))}
        </Links>
        <LoginBtn type="button" onClick={() => navigate('/login')}>
          Login
        </LoginBtn>
      </Inner>
    </Bar>
  );
};

export default Nav;

const Bar = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
`;

const Inner = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  height: 72px;
  padding: 0 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;

const Links = styled.nav`
  display: flex;
  gap: 40px;

  a {
    font-family: ${fonts.body};
    font-weight: 400;
    font-size: 15px;
    color: ${colors.textSoft};
    text-decoration: none;
    transition: color 0.15s ease;
  }
  a:hover {
    color: ${colors.cyan};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const LoginBtn = styled.button`
  padding: 8px 22px;
  border: 0.75px solid rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  font-family: ${fonts.condensed};
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${colors.ink};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  &:hover {
    border-color: ${colors.cyan};
    background: rgba(56, 200, 212, 0.06);
  }
`;
